import React from "react";
import SeoPage from "../../components/SeoPage";
import RELATED from "../../data/related";
import { faqsByTopic } from "../../data/faqs";

export default function HowToEditCsvFiles() {
    return (
        <SeoPage
            title="How to Edit CSV Files — Step-by-Step Guide"
            description="Edit a CSV file in three steps: open it in a CSV editor, click the cells you want to change, and save. Works on phone, tablet, and desktop."
            breadcrumbs={[{ label: "Home", href: "/" }, { label: "How to Edit CSV Files" }]}
            eyebrow="/ how to"
            h1="How to edit a CSV file (the simple way)"
            heroLead="Editing a CSV file should take 30 seconds. Here's how to fix typos, add or remove rows, clean up an export, and save the file back — without firing up Excel."
            sections={[
                { heading: "Step 1 — Open the file",
                    body: "Go to opencsv.io and either drag your CSV file onto the page or click 'Open' in the toolbar to pick a file. The file loads entirely in your browser; nothing is uploaded.",
                },
                { heading: "Step 2 — Make your edits",
                    sub: [
                        { heading: "Edit a cell", body: "Click any cell. Type the new value. Press Enter or Tab to move to the next cell." },
                        { heading: "Add a row", body: "Click 'Row' in the toolbar to add a new blank row at the bottom." },
                        { heading: "Add a column", body: "Click 'Column' in the toolbar. Edit the header to give it a name." },
                        { heading: "Delete a row or column", body: "Each row has a small trash icon at the right. Each column header has one too. One click, gone." },
                        { heading: "Search inside the file", body: "Use the search box to filter rows in real-time — useful for finding records to edit or rows you want to delete." },
                    ],
                },
                { heading: "Step 3 — Save",
                    body: "When you're done, you have two options:",
                    bullets: [
                        "Click 'Download' to save the edited CSV to your device",
                        "Click 'Save' to put it in your private cloud library (paid users)",
                    ],
                    callout: "Both options preserve your column order, headers, and quoting exactly as they should be — so the file is ready to import into other tools."
                },
                { heading: "Common edits people make",
                    bullets: [
                        "Fix a typo in a customer name or email",
                        "Remove duplicate rows from an export",
                        "Add a new product to a Shopify import",
                        "Update prices across an inventory list",
                        "Strip out a column you don't want shared",
                        "Add a header row to a file someone forgot to label",
                    ],
                },
                { heading: "What to avoid",
                    body: "Don't open CSV files in Excel just to edit them — Excel often reformats data on save (drops leading zeros, converts dates, mangles long numbers). If you need to edit data without changing it, a dedicated CSV editor like OpenCSV is safer.",
                },
            ]}
            faqs={faqsByTopic("edit", "lightweight", "general")}
            related={[RELATED.editor, RELATED.viewer, RELATED.light, RELATED.vs, RELATED.use, RELATED.faq]}
        />
    );
}
